$(document).ready(function() {
  $('.product-gallery__video video').on('click touchstart', function() {
      var video = $(this).get(0);
      if (video.paused) {
          $(this).removeClass().addClass('is-playing');
          $(this)[0].play();
      } else {
          $(this).removeClass().addClass('is-paused');
          $(this)[0].pause();
      }
      return false;
  });
});

